module.exports = __webpack_public_path__ + "img/Path 517.589cc484.svg";